(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-edicion-limitada"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pad = (n) => String(n).padStart(2, '0');

  /* Galería: miniaturas como pestañas (clic, flechas, Inicio/Fin) y deslizar en táctil */
  function initGallery(gallery) {
    const slides = [...gallery.querySelectorAll('[data-gm-ed-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gm-ed-thumb]')];
    if (slides.length < 2 || thumbs.length !== slides.length) return;
    const counter = gallery.querySelector('[data-gm-ed-count]');
    const caption = gallery.querySelector('[data-gm-ed-caption]');
    const stage = gallery.querySelector('[data-gm-ed-stage]');
    let current = 0;
    let warmed = false;

    const warm = () => {
      if (warmed) return;
      warmed = true;
      slides.forEach((s) => s.querySelector('img')?.setAttribute('loading', 'eager'));
    };

    const go = (index, focus) => {
      const next = (index + slides.length) % slides.length;
      if (next === current) return;
      [current, next].forEach((i) => {
        const on = i === next;
        slides[i].classList.toggle('is-active', on);
        slides[i].toggleAttribute('inert', !on);
        slides[i].setAttribute('aria-hidden', String(!on));
        thumbs[i].classList.toggle('is-active', on);
        thumbs[i].setAttribute('aria-selected', String(on));
        thumbs[i].tabIndex = on ? 0 : -1;
      });
      current = next;
      if (counter) counter.textContent = `${pad(next + 1)} / ${pad(slides.length)}`;
      if (caption) caption.textContent = slides[next].dataset.caption || '';
      if (focus) thumbs[next].focus();
      thumbs[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => go(i));
      thumb.addEventListener('pointerenter', warm, { once: true });
    });

    thumbs[0].parentElement.addEventListener('keydown', (e) => {
      const keys = { ArrowRight: current + 1, ArrowDown: current + 1, ArrowLeft: current - 1, ArrowUp: current - 1, Home: 0, End: slides.length - 1 };
      if (!(e.key in keys)) return;
      e.preventDefault();
      go(keys[e.key], true);
    });

    let startX = null;
    let startY = 0;
    stage.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse') return;
      startX = e.clientX;
      startY = e.clientY;
      warm();
    }, { passive: true });
    stage.addEventListener('pointerup', (e) => {
      if (startX === null) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(current + (dx < 0 ? 1 : -1));
    });
    stage.addEventListener('pointercancel', () => { startX = null; });
  }

  /* Barra fija: visible cuando el botón del hero ha salido por arriba y antes de llegar al cierre */
  function initSticky(root, onToggle) {
    const bar = root.querySelector('[data-gm-ed-sticky]');
    const heroCta = root.querySelector('[data-gm-ed-cta="hero"]');
    if (!bar || !heroCta || !('IntersectionObserver' in window)) return null;
    const endCta = root.querySelector('[data-gm-ed-cta="cierre"]');
    const docEl = document.documentElement;
    let pastHero = false;
    let reachedEnd = false;
    let shown = false;

    const render = () => {
      const show = pastHero && !reachedEnd;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.toggleAttribute('inert', !show);
      bar.setAttribute('aria-hidden', String(!show));
      /* Misma variable que usa el reposicionado del lanzador de Growave en el resto de la tienda */
      /* Altura ocupada desde el borde inferior: alto de la barra + su separación (flotante en escritorio) */
      const occupied = bar.offsetHeight + (parseFloat(getComputedStyle(bar).bottom) || 0);
      docEl.style.setProperty('--gm-sticky-atc-h', show ? `${Math.round(occupied)}px` : '0px');
      if (onToggle) onToggle();
    };

    /* Márgenes enormes para que solo cuente un borde de la pantalla: así el estado
       cambia aunque la página salte de golpe (ancla, restauración del scroll). */
    /* El tema da a esta variable un valor por defecto (8rem): sin barra visible debe ser 0 */
    docEl.style.setProperty('--gm-sticky-atc-h', '0px');

    const observers = [];
    const heroObs = new IntersectionObserver(([entry]) => {
      pastHero = !entry.isIntersecting;
      render();
    }, { rootMargin: '0px 0px 100000px 0px' });
    heroObs.observe(heroCta);
    observers.push(heroObs);

    if (endCta) {
      const endObs = new IntersectionObserver(([entry]) => {
        reachedEnd = entry.isIntersecting;
        render();
      }, { rootMargin: '100000px 0px 0px 0px' });
      endObs.observe(endCta);
      observers.push(endObs);
    }

    return () => {
      observers.forEach((o) => o.disconnect());
      docEl.style.setProperty('--gm-sticky-atc-h', '0px');
    };
  }

  /* Lanzador de Growave («Recompensas»). Misma lógica que la barra fija de la ficha normal
     (sticky-add-to-cart de main-product), que esta plantilla no carga: X para cerrarlo,
     cierre recordado por producto (gm_gw_launcher_dismissed), eventos GA y subida del
     lanzador por encima de la barra fija de esta sección (--gm-sticky-atc-h). */
  function initGrowave(root) {
    const STORAGE_KEY = 'gm_gw_launcher_dismissed';
    const PRODUCT = root.dataset.productHandle || '';
    let launcher = null;
    let xBtn = null;
    let timer = 0;

    const dismissed = () => {
      try {
        const v = localStorage.getItem(STORAGE_KEY);
        if (v === null) return false;
        if (v === PRODUCT) return true;
        localStorage.removeItem(STORAGE_KEY);
        return false;
      } catch (e) { return false; }
    };
    const setDismissed = () => { try { localStorage.setItem(STORAGE_KEY, PRODUCT); } catch (e) { /* sin almacenamiento */ } };
    const track = (name) => {
      if (typeof window.gtag === 'function') window.gtag('event', name, { event_category: 'fidelizacion', event_label: 'launcher_flotante' });
    };
    const find = () => {
      const host = document.querySelector('.gw-rd-popup-widget-placeholder');
      return host?.shadowRoot?.querySelector('.gw-rd-popup-widget-launcher--BL, .gw-launcher--position-BL') || null;
    };
    const button = () => (launcher.classList.contains('gw-launcher') ? launcher : launcher.querySelector('.gw-launcher') || launcher);
    const hideAll = () => {
      if (launcher) launcher.style.setProperty('display', 'none', 'important');
      if (xBtn) xBtn.style.display = 'none';
    };
    const ensureX = () => {
      if (xBtn) return;
      xBtn = document.createElement('button');
      xBtn.type = 'button';
      xBtn.className = 'gm-gw-close';
      xBtn.setAttribute('aria-label', 'Cerrar Recompensas');
      xBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" d="M6 6l12 12M18 6L6 18"/></svg>';
      xBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        track('cerrar_recompensas');
        setDismissed();
        hideAll();
      });
      root.appendChild(xBtn);
    };

    const apply = () => {
      timer = 0;
      if (!launcher || !launcher.isConnected) launcher = find();
      if (!launcher) return;
      if (dismissed()) { hideAll(); return; }
      if (!launcher.dataset.gmEdBottom) launcher.dataset.gmEdBottom = getComputedStyle(launcher).bottom || '10px';
      launcher.style.transition = 'bottom .35s ease';
      launcher.style.bottom = `calc(${launcher.dataset.gmEdBottom} + var(--gm-sticky-atc-h, 0px))`;
      if (!launcher.dataset.gmEdTracked) {
        launcher.dataset.gmEdTracked = 'true';
        launcher.addEventListener('click', () => track('click_recompensas'), true);
      }
      /* La X se ancla con CSS al mismo borde inferior que el lanzador (misma variable y misma
         transición), así se mueven juntos al hacer scroll, al mostrarse la barra o al cambiar
         la barra del navegador móvil. Aquí solo se calculan las medidas fijas. */
      const box = launcher.getBoundingClientRect();
      const r = button().getBoundingClientRect();
      if (!r.width || !r.height) return;
      const SIZE = 22;
      const base = parseFloat(launcher.dataset.gmEdBottom) || 0;
      const fromBoxBottom = box.bottom - r.bottom;
      ensureX();
      xBtn.style.setProperty('--gm-gw-x-left', `${Math.round(r.right - SIZE + 5)}px`);
      xBtn.style.setProperty('--gm-gw-x-bottom', `${Math.round(base + fromBoxBottom + r.height + 5 - SIZE)}px`);
      xBtn.style.display = 'flex';
    };
    const schedule = (delay = 150) => { clearTimeout(timer); timer = setTimeout(apply, delay); };

    schedule();
    window.addEventListener('load', () => schedule());
    window.addEventListener('resize', () => schedule());
    if ('MutationObserver' in window) {
      const mo = new MutationObserver(() => { if (find()) { mo.disconnect(); schedule(); } });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => mo.disconnect(), 15000);
    }
    /* Por si el lanzador aún no estaba al mostrarse la barra por primera vez */
    return () => { if (!xBtn) schedule(); };
  }

  /* Actualiza numeración, stock y botones si la página vuelve de la caché del navegador
     (botón Atrás) o tras más de un minuto en otra pestaña. Usa la Section Rendering API.
     Solo vuelve a leer lo que pinta Liquid: el frontend nunca escribe la numeración. */
  function initLive(root) {
    const sectionId = root.dataset.sectionId;
    if (!sectionId || !window.fetch || !window.DOMParser) return;
    let hiddenAt = 0;

    const refresh = async () => {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        const res = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const freshRoot = doc.querySelector('[data-gm-ed]');
        if (!freshRoot) return;
        root.classList.toggle('gm-ed--soldout', freshRoot.classList.contains('gm-ed--soldout'));
        root.querySelectorAll('[data-gm-ed-live]').forEach((el) => {
          const fresh = freshRoot.querySelector(`[data-gm-ed-live="${el.dataset.gmEdLive}"]`);
          if (fresh && fresh.innerHTML !== el.innerHTML) el.innerHTML = fresh.innerHTML;
        });
      } catch (e) { /* sin red: se mantiene lo que pintó Liquid */ }
    };

    window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { hiddenAt = Date.now(); return; }
      if (hiddenAt && Date.now() - hiddenAt > 60000) refresh();
    });
  }

  /* GA4 opcional (ajuste de la sección). add_to_cart al enviar el formulario, no al clic. */
  function initAnalytics(root) {
    if (!root.dataset.gmEdGa4) return;
    let item;
    try { item = JSON.parse(root.dataset.gmEdGa4); } catch (e) { return; }
    window.dataLayer = window.dataLayer || [];
    const push = (event) => {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event, ecommerce: { currency: item.currency, value: item.price, items: [item] } });
    };
    push('view_item');
    root.addEventListener('submit', (e) => {
      if (e.target.closest('.gm-ed-buy')) push('add_to_cart');
    });
  }

  const teardowns = new WeakMap();

  function init(root) {
    if (!root || root.dataset.gmEdReady) return;
    root.dataset.gmEdReady = 'true';
    root.querySelectorAll('[data-gm-ed-gallery]').forEach(initGallery);
    const onStickyToggle = initGrowave(root);
    const stop = initSticky(root, onStickyToggle);
    if (stop) teardowns.set(root, stop);
    initLive(root);
    initAnalytics(root);
  }

  document.querySelectorAll('[data-gm-ed]').forEach(init);

  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-gm-ed]')));
  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('[data-gm-ed]');
    if (root && teardowns.has(root)) teardowns.get(root)();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-landing-producto"] && !Shopify.designMode) return;
  try {
    
  /* GM. Landing producto — barra fija, vídeo bajo demanda, galería, selector de opciones y GA4 */
  (function () {
    'use strict';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* ---------- Barra de compra fija ---------- */
    if (!customElements.get('gm-lp-sticky')) {
      customElements.define('gm-lp-sticky', class extends HTMLElement {
        connectedCallback() {
          var hero = document.getElementById(this.dataset.anchor);
          this.trigger = hero && (hero.querySelector('[data-gm-lp-buy-anchor]') || hero);
          if (!this.trigger) return;
          this.pastTrigger = false;
          this.blockers = new Map();
          this.observer = new IntersectionObserver(this.onIntersect.bind(this), { threshold: 0 });
          this.observer.observe(this.trigger);
          document.querySelectorAll('[data-gm-lp-hide-sticky]').forEach(function (el) {
            this.observer.observe(el);
          }, this);
        }
        onIntersect(entries) {
          entries.forEach(function (entry) {
            if (entry.target === this.trigger) {
              this.pastTrigger = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            } else {
              this.blockers.set(entry.target, entry.isIntersecting);
            }
          }, this);
          var blocked = false;
          this.blockers.forEach(function (visible) { if (visible) blocked = true; });
          this.setVisible(this.pastTrigger && !blocked);
        }
        setVisible(show) {
          this.classList.toggle('is-visible', show);
          this.toggleAttribute('inert', !show);
          this.setAttribute('aria-hidden', String(!show));
          /* Misma variable que usa el reposicionado del lanzador de Growave */
          document.documentElement.style.setProperty('--gm-sticky-atc-h', show ? this.offsetHeight + 'px' : '0px');
        }
        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          document.documentElement.style.removeProperty('--gm-sticky-atc-h');
        }
      });
    }

    /* ---------- Vídeo bajo demanda ---------- */
    if (!customElements.get('gm-lp-video')) {
      customElements.define('gm-lp-video', class extends HTMLElement {
        connectedCallback() {
          var button = this.querySelector('[data-gm-lp-play]');
          if (button) button.addEventListener('click', this.load.bind(this), { once: true });
        }
        load() {
          var template = this.querySelector('[data-gm-lp-video-template]');
          if (!template || !template.content.firstElementChild) return;
          var player = template.content.firstElementChild.cloneNode(true);
          this.querySelectorAll('[data-gm-lp-play], .gm-lp-video__poster').forEach(function (el) { el.remove(); });
          this.appendChild(player);
          if (player.tagName === 'VIDEO') {
            var playing = player.play();
            if (playing && playing.catch) playing.catch(function () {});
          }
          player.focus();
        }
      });
    }

    /* ---------- Vídeos de la galería: solo en pantalla ---------- */
    if (!customElements.get('gm-lp-autoplay')) {
      customElements.define('gm-lp-autoplay', class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video || reduceMotion.matches) return;
          this.video.muted = true;
          this.observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                var playing = this.video.play();
                if (playing && playing.catch) playing.catch(function () {});
              } else {
                this.video.pause();
              }
            }, this);
          }.bind(this), { threshold: 0.25 });
          this.observer.observe(this);
        }
        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      });
    }

    if (window.GMLandingInit) return;
    window.GMLandingInit = true;

    /* ---------- Selector de opciones: precio ---------- */
    document.addEventListener('change', function (event) {
      var select = event.target.closest && event.target.closest('[data-gm-lp-variant-select]');
      if (!select) return;
      var option = select.options[select.selectedIndex];
      var scope = select.closest('[data-gm-lp-product]') || select.form;
      scope.querySelectorAll('[data-gm-lp-price]').forEach(function (el) {
        el.textContent = option.dataset.price;
      });
      var button = select.form.querySelector('[data-gm-lp-atc]');
      if (button) {
        button.dataset.variantId = option.value;
        button.dataset.price = option.dataset.priceRaw;
        button.dataset.itemVariant = option.textContent.trim();
      }
    });

    /* ---------- GA4 (dataLayer) ---------- */
    function pushEcommerce(eventName, el, price, variantTitle) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: eventName,
        ecommerce: {
          currency: el.dataset.currency,
          value: parseFloat(price) || 0,
          items: [{
            item_id: el.dataset.itemId,
            item_name: el.dataset.itemName,
            item_brand: el.dataset.itemBrand,
            item_category: el.dataset.itemCategory,
            item_variant: variantTitle,
            item_list_name: el.dataset.itemListName || undefined,
            price: parseFloat(price) || 0,
            quantity: 1
          }]
        }
      });
    }

    function trackView() {
      var hero = document.querySelector('[data-gm-lp-view-item]');
      if (hero) pushEcommerce('view_item', hero, hero.dataset.price, hero.dataset.itemVariant);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', trackView);
    } else {
      trackView();
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-gm-lp-atc]');
      if (!button || button.disabled) return;
      pushEcommerce('add_to_cart', button, button.dataset.price, button.dataset.itemVariant);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function fmtQtyPrice(cents) {
    return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
  }

  function updateQuantityPricing() {
    const dataEl = document.querySelector('[data-js-variant-data]');
    const qtyInput = document.querySelector('[data-js-product-quantity] .qty-selector');
    if (!dataEl || !qtyInput) return;

    try {
      const variant = JSON.parse(dataEl.textContent);
      if (!variant || !variant.price) return;

      const qty = parseInt(qtyInput.value, 10) || 1;
      const totalPrice = variant.price * qty;
      const totalCompare = variant.compare_at_price ? variant.compare_at_price * qty : 0;

      const priceBlock = document.querySelector('[data-update-block="price-extended"]');
      if (priceBlock) {
        const priceValueEl = priceBlock.querySelector('[data-js-price-value]');
        if (priceValueEl) priceValueEl.textContent = fmtQtyPrice(totalPrice);

        const compareValueEl = priceBlock.querySelector('[data-js-compare-value]');
        const savingValueEl = priceBlock.querySelector('[data-js-saving-value]');

        if (totalCompare > totalPrice) {
          if (compareValueEl) compareValueEl.textContent = fmtQtyPrice(totalCompare);
          if (savingValueEl) savingValueEl.textContent = fmtQtyPrice(totalCompare - totalPrice);
        }
      }

      if (variant.available) {
        const textEl = document.querySelector('[data-js-product-add-to-cart-text]');
        if (textEl) {
          let atcPriceEl = textEl.querySelector('[data-js-atc-total-price]');
          if (!atcPriceEl) {
            atcPriceEl = document.createElement('span');
            atcPriceEl.className = 'add-to-cart__price';
            atcPriceEl.setAttribute('data-js-atc-total-price', '');
            textEl.appendChild(atcPriceEl);
          }
          atcPriceEl.textContent = ' · ' + fmtQtyPrice(totalPrice);
        }
      } else {
        const existingPriceEl = document.querySelector('[data-js-atc-total-price]');
        if (existingPriceEl) existingPriceEl.remove();
      }
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', function() {
    const qtyInput = document.querySelector('[data-js-product-quantity] .qty-selector');
    const dataEl = document.querySelector('[data-js-variant-data]');

    if (qtyInput) {
      ['input', 'change'].forEach(function(evt) {
        qtyInput.addEventListener(evt, updateQuantityPricing);
      });
    }

    document.querySelectorAll('[data-js-product-quantity] .qty-minus, [data-js-product-quantity] .qty-plus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        setTimeout(updateQuantityPricing, 0);
      });
    });

    if (dataEl) {
      new MutationObserver(updateQuantityPricing).observe(dataEl, { characterData: true, childList: true, subtree: true });
    }

    updateQuantityPricing();
  });

  } catch(e) { console.error(e); }
})();
})();
